import { Select, MenuItem } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import ColorConstants from '../../../defaults/ColorConstants';

const theme = createTheme({
  overrides: {
  },
});

const useStyles = makeStyles({
  root: {
    "&:hover": {
      borderLeft: `4px solid ${ColorConstants.BlueAlien} !important`,
    }
  },
});

export default function ValueTypeChooser({id, selectedValueType, onChange}) {
  const classes = useStyles();
  const handleOptionChange = e => {
    onChange(e);
  };

  return (
    <ThemeProvider theme={theme}>
      <Select
        id={id}
        value={selectedValueType ? selectedValueType : ''}
        onChange={handleOptionChange}
        sx={{ width: 300 }}
        MenuProps={{
              sx: {
                "&& .Mui-selected": {
                  borderLeft: `4px solid ${ColorConstants.BlueAlien} !important`
                },
              }
            }}
      >
        <MenuItem value="value" classes={{root: classes.root, selected: classes.selected}} style={{ display: 'block', padding: 5, borderLeft: `4px solid ${ColorConstants.WhiteAlien}`}}>Value</MenuItem>
        <MenuItem value="unique" classes={{root: classes.root, selected: classes.selected}} style={{ display: 'block', padding: 5, borderLeft: `4px solid ${ColorConstants.WhiteAlien}`}}>Unique</MenuItem>
      </Select>
    </ThemeProvider>
  );
}